import Vue from 'vue';
import Vuetify, { VSnackbar, VIcon, VBtn } from 'vuetify/lib';
import VuetifyToast from 'vuetify-toast-snackbar'


Vue.use(VuetifyToast, {
    x: '', // default
    y: 'bottom', // default
    color: 'info', // default
    icon: '',
    timeout: 7000, // default
    showClose: true,
    closeIcon: 'mdi-close',
    dismissable: true, // default
    autoHeight: false, // default
    multiLine: false, // default
    vertical: false, // default
    property: '$toast' // default
});

Vue.use(Vuetify, {
    components: {
        VSnackbar,
        VIcon,
        VBtn
    }
});

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#0066b3',
                secondary: '#ff6600',
                accent: '#0091FF',
            },
        },
    },
});
